@import (reference) '../../../../../constants/spacing.module.less';

.shipment-items-section-header-buttons {
  gap: @space-16;
}

.split-ship-button {
  height: 32px;
}

.icon {
  height: 14px;
  padding-right: 2px;
  margin-bottom: -2px;
}

.shipment-items-section-header {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.shipment-items-section-content {
  padding: @space-0;
}

.divider {
  height: 20px;
  border-right: solid 1px var(--default--border-color--10);
}

.shipment-items-section-header-labels {
  gap: @space-16;
}

.verified-label {
  color: var(--success--text-color--1);
  display: flex;
  align-items: center;
  gap: @space-4;
}

.verified-tooltip {
  display: flex;
  flex-direction: column;
}

.verified-icon {
  width: 16px;
  height: 16px;
  fill: var(--success--icon--fill-color--1);
}
